import {useAxiosPlugin} from '@/core/plugins/axios';
import apiConstants from '@/core/constants/apiConstants';

export const useChartsRepository = (chartType = null) => {
    if (!chartType) {
        console.error('useChartsRepository: The chartType must be specified!');
    }

    async function getChartData(payload) {
        try {
            const {data} = await useAxiosPlugin().httpPost(apiConstants.CHARTS_DATA(chartType), payload);
    
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    return {
        getChartData,
    };
};
